import { render, staticRenderFns } from "./HelpLink.vue?vue&type=template&id=f5f95b76&scoped=true"
import script from "./HelpLink.vue?vue&type=script&lang=js"
export * from "./HelpLink.vue?vue&type=script&lang=js"
import style0 from "./HelpLink.vue?vue&type=style&index=0&id=f5f95b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f95b76",
  null
  
)

export default component.exports